<template>
  <section>
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@40,400,0,0"
    />
   <VerReporte />
    <!--<VerDocumento />-->
    <VerSeguimientoVacacion/> 
    <v-card class="p-0">
      <v-card-text class="p-0">
        <!-- Cabecera del formulario -->
        <v-card-title class="headline">
          <v-flex xs12>
            <span class="material-symbols-outlined">
              leaderboard
            </span>
            Reporte de vacaciones
          </v-flex>
       
          <v-spacer></v-spacer>
        </v-card-title>
        <!-- Cuerpo del formulario -->
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-card-text>
            <v-container grid-list-md class="p-0" style="min-width: 100%;">
              <v-layout row wrap>
                <v-flex xs12 md6 class="py-0">
                  <v-text-field
                    class="text-field-reducido"
                    type="date"
                    v-model="form.fecha_inicio"
                    label="Fecha inicio"
                    @input="obtenerListaFuncionarios()"
                    :rules="$validate(['required'])"
                    required
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex xs12 md6 class="py-0">
                  <v-text-field
                    class="text-field-reducido"
                    type="date"
                    v-model="form.fecha_fin"
                    label="Fecha fin"
                    @input="
                      obtenerListaFuncionarios(
                        form.fecha_inicio,
                        form.fecha_fin
                      )
                    "
                    :rules="$validate(['required'])"
                    required
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex md12 class="py-0">
                  <v-autocomplete
                    class="text-field-reducido"
                    :items="unidades_generales"
                    item-value="id_unidad"
                    item-text="nombre_unidad"
                    v-model="form.id_unidad_general"
                    @input="obtenerListaFuncionarios()"
                    label="Unidad general"
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex md12 class="py-0">
                  <v-autocomplete
                    class="text-field-reducido"
                    :items="unidades_especificas"
                    item-value="id_unidad"
                    item-text="nombre_unidad"
                    v-model="form.id_unidad_especifica"
                    @input="obtenerListaFuncionarios()"
                    label="Unidad especifica"
                    maxlength="50"
                    clearable
                    outline
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 md4 class="py-0">
                  <v-text-field
                    class="text-field-reducido"
                    v-model="form.paterno"
                    label="Paterno"
                    @input="obtenerListaFuncionarios()"
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex xs12 sm6 md4 class="py-0">
                  <v-text-field
                    class="text-field-reducido"
                    v-model="form.materno"
                    label="Materno"
                    @input="obtenerListaFuncionarios()"
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex xs12 sm6 md4 class="py-0">
                  <v-text-field
                    class="text-field-reducido"
                    v-model="form.nombres"
                    label="Nombres"
                    @input="obtenerListaFuncionarios()"
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex xs12 sm6 md4 class="py-0">
                  <v-text-field
                    class="text-field-reducido"
                    v-model="form.ci"
                    label="Cédula de identidad"
                    @input="obtenerListaFuncionarios()"
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex xs12 sm6 md4 class="py-0">
                  <v-text-field
                    class="text-field-reducido"
                    v-model="form.item"
                    label="Item"
                    @input="obtenerListaFuncionarios()"
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex xs12 sm6 md4 class="py-0">
                  <v-autocomplete
                    class="text-field-reducido"
                    :items="estados"
                    item-value="id"
                    item-text="descripcion"
                    v-model="form.id_estado"
                    @input="obtenerListaFuncionarios()"
                    label="Estado"
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex xs12 sm6 md4 class="py-0">
                  <v-autocomplete
                    class="text-field-reducido"
                    :items="entregados"
                    item-value="id"
                    item-text="entregado"
                    v-model="form.entregado"
                    @input="obtenerListaFuncionarios()"
                    label="Estado entregado"
                    outline
                    clearable
                  />
                </v-flex>
              </v-layout>
              <v-btn
                :disabled="!bandera_boton_buscar"
                color="rgba(31,14,180,0.3)"
                @click="obtenerListaFuncionarios()"
                type="submit"
              >
                <v-icon>search</v-icon>
                Buscar
              </v-btn>
              <v-btn
                color="rgba(158,11,127,0.6)"
                @click="limpiarCampos()"
                type="submit"
              >
                <v-icon>redo</v-icon>
                Limpiar
              </v-btn>
              <!-- <v-btn
                :disabled="!bandera_boton_buscar"
                color="rgba(50,150,40,0.7)"
                title="Ver reporte "
                type="submit"
                @click.prevent="verReporte(form, 6)"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn> -->
            </v-container>
          </v-card-text>
        </v-form>
        <v-data-table
          :headers="headers"
          :items="lista_funcionarios"
          class="elevation-1"
          :no-data-text="
            loading ? 'Cargando...' : 'No se tiene registros de permisos'
          "
          :disable-initial-sort="true"
          :loading="loading"
          no-results-text="No se encontraron coincidencias"
        >
          <template v-slot:items="props">
            <td class="text-xs-center">
              {{ props.item.uni }}
            </td>
            <!-- <td class="text-xs-center">
              {{ $moment(props.item.fecha_incor).format("DD/MM/YYYY") }}
            </td> -->
            <td class="text-xs-center">
              {{ props.item.nom }} {{ props.item.pat }} {{ props.item.mat }}
            </td>
            <td class="text-xs-center">
              {{ props.item.item }}
            </td>
            <td class="text-xs-center">
              {{ props.item.nro_doc }}
            </td>
            <td class="text-xs-center">
              {{ props.item.cargo }}
            </td>
            <td class="text-xs-center">
              {{ props.item.secuencia }}
            </td>
            <td class="text-xs-center">
              {{ props.item.descripcion }}
            </td>
            <td class="text-xs-center">
              {{
                props.item.fecha_desde
                  ? $moment(props.item.fecha_desde).format("DD/MM/YYYY")
                  : ""
              }}
            </td>
            <td class="text-xs-center">
              {{
                props.item.fecha_hasta
                  ? $moment(props.item.fecha_hasta).format("DD/MM/YYYY")
                  : ""
              }}
            </td>
            <td class="text-xs-center">
              {{ props.item.total_dias }}
            </td>
            <td class="text-xs-center">
              {{ props.item.entregado }}
            </td>
            <td class="text-xs-center">
              <!-- Boton para ver el seguimiento del permiso -->
              <v-btn
                color="#006A8E"
                @click.prevent="verSeguimientoVacacion(props.item)"
                icon
                title="Ver seguimiento"
                outline
              >
                <v-icon>visibility</v-icon>
              </v-btn>
           <!-- Reporte de programación uso -->
           <v-btn
                v-if="(props.item.id_estado == 65 || props.item.id_estado == 55 || props.item.id_estado == 58) && (!props.item.id_padre_vacacion || props.item.id_padre_vacacion==null)"
                color="rgba( 36, 113, 163,0.7)"
                @click.prevent="verReporte(props.item, 0)"
                icon
                title="Ver reporte de programación de vacación"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>
                 <!-- Reporte de reprogramación uso -->
                 <v-btn
                v-if="(props.item.id_estado == 65 || props.item.id_estado == 55 || props.item.id_estado == 58) && (props.item.id_padre_vacacion || props.item.id_padre_vacacion!=null)"
                color="rgba( 36, 113, 163,0.7)"
                @click.prevent="verReporte(props.item, 1)"
                icon
                title="Ver reporte de programación de vacación"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>
               <!-- Reporte de reprogramación -->
               <v-btn
                v-if="props.item.id_estado == 57"
                color="rgba( 142, 68, 173 ,0.7)"
                @click.prevent="verReporte(props.item, 2)"
                icon
                title="Ver reporte de reprogramación de vacación"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import validate from "@/common/mixins/validate";
import VerSeguimientoVacacion from "./dialogs/VerSeguimientoVacacion.vue"
 import VerReporte from "../vacacion_uso/dialogs/VerReporte.vue";
// import VerDocumento from "./dialogs/VerDocumento.vue";


export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [],
  // Variables iniciales del componente
  mixins: [validate],
  data() {
    return {
      form: {},
      valid: false,
      validated: 0,
      bandera_boton_buscar: true,
      tipo_permisos: [],
      entregados:[{id:'S',entregado:'ENTREGADO'},{id:'N',entregado:'NO ENTREGADO'},],
      loading: false,
      headers: [
        {
          text: "Unidad",
          value: "uni",
          align: "center"
        },
        {
          text: "Nombre",
          value: "nom",
          align: "center"
        },
        {
          text: "Item",
          value: "item",
          align: "center"
        },
        {
          text: "CI",
          value: "nro_doc",
          align: "center"
        },
        {
          text: "Cargo",
          value: "cargo",
          align: "center"
        },
        {
          text: "Nro. de papeleta",
          value: "secuencia",
          align: "center"
        },
        {
          text: "Estado",
          value: "descripcion",
          align: "center"
        },
        {
          text: "Fecha salida",
          value: "fecha_desde",
          align: "center"
        },
        {
          text: "Fecha fin",
          value: "fecha_hasta",
          align: "center"
        },
        {
          text: "Total dias",
          value: "total_dias",
          align: "center"
        },
        {
          text: "Estado entrega",
          value: "entregado",
          align: "center"
        },
        { text: this.$t("common.actions"), sortable: false }
      ],

      unidades_generales: [],
      unidades_especificas: [],
      lista_funcionarios: [],
      estados: []
    };
  },
  async created() {
    await this.obtenerEstados();
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    await this.obtenerTipoPermisos();
    await this.cargarListaUnidadesGenerales();
    await this.cargarListaUnidadesEspecificas();
    this.form.id_unidad_general = 0;
    this.form.id_unidad_especifica = 0;
    this.form.materno = "";
    this.form.paterno = "";
    this.form.nombres = "";
    this.form.ci = "";
    this.form.item = "";
    //asignar primer y ultimo dia del año
    let año = new Date().getFullYear() + "";
    let primer_dia = año + "-01-01";
    let ultimo_dia = año + "-12-31";
    this.fecha_desde = primer_dia;
    this.fecha_hasta = ultimo_dia;

    /////
    this.form.fecha_inicio = primer_dia;
    this.form.fecha_fin = ultimo_dia;
    this.bandera_boton_buscar = true;

    await this.obtenerListaFuncionarios(primer_dia, ultimo_dia);
  },
  // Métodos y funciones del componente
  methods: {
    // Metodo para cargar estados
    async obtenerEstados() {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
              estados(lista_estados:"22,51,73,66,54,72,55,58,65,56,57,67,68,69,70"){
                count
                rows{
                  descripcion
                  id
                }
              }
            }
          `
        });
        this.estados = res.estados.rows;
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerListaFuncionarios(fecha_desde, fecha_hasta) {
      this.loading = true;
      try {
        this.bandera_boton_buscar = true;
        if (this.form.fecha_inicio && this.form.fecha_fin) {
          this.lista_funcionarios = [];
          if (this.form.materno) {
            this.form.materno = this.form.materno.toUpperCase();
          }
          if (this.form.nombres) {
            this.form.nombres = this.form.nombres.toUpperCase();
          }
          if (this.form.paterno) {
            this.form.paterno = this.form.paterno.toUpperCase();
          }
          if (!this.form.id_unidad_general) {
            this.form.id_unidad_general = 0;
          }
          if (!this.form.id_unidad_especifica) {
            this.form.id_unidad_especifica = 0;
          }
          if (!this.form.materno) {
            this.form.materno = "";
          }
          if (!this.form.paterno) {
            this.form.paterno = "";
          }
          if (!this.form.nombres) {
            this.form.nombres = "";
          }
          if (!this.form.ci) {
            this.form.ci = "";
          }
          if (!this.form.item) {
            this.form.item = "";
          }
          if (!this.form.id_estado) {
            this.form.id_estado = 0;
          }
          if (!this.form.entregado) {
            this.form.entregado = "";
          }
          let res = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"SELECT * FROM vacaciones.fn_buscador_gral_vacaciones('${this.form.fecha_inicio}','${this.form.fecha_fin}',${this.form.id_unidad_general},'${this.form.paterno}','${this.form.materno}','${this.form.nombres}','${this.form.ci}','${this.form.item}',${this.form.id_unidad_especifica},'',${this.form.id_estado},'${this.form.entregado}') AS (id_persona integer,id_unidad integer,id_padre integer,uni varchar,pat varchar,mat varchar,nom varchar,nro_doc varchar,item varchar,cargo text,fecha_desde text, fecha_hasta text, total_dias varchar, id_estado text, descripcion text,id_vacacion_programada integer,secuencia integer,id_padre_vacacion integer,entregado text) "){
                  respuesta
                }
              }
            `
          });

          if (res.runQuery.respuesta.length != 0) {
            this.lista_funcionarios = res.runQuery.respuesta;
          }
        } else {
          this.bandera_boton_buscar = false;
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },
    // Meto para ver el seguimiento de la vacacion
    verSeguimientoVacacion(item) {
      this.$bus.$emit("openDialogVerSeguimientoVacacion", item);
    },
    async obtenerTipoPermisos() {
      try {
        let res = await this.$service.graphql({
          query: `
            query {
							tipoPermisos(id_estado: 19) {
                rows {
                  id
                  descripcion
                  refrigerio
                  tiempo_maximo
                  tiempo_minimo
                  aprobado
                  estado {
                    descripcion
                    abrev
                  }
                }
              }
            }
          `
        });
        let tipo_per = [];
        // res.tipoPermisos.rows.forEach((element) => {
        //   if (element.id != 24) {
        //     tipo_per.push(element);
        //   }
        // });
        this.tipo_permisos = res.tipoPermisos.rows;
      } catch (error) {}
    },
    limpiarCampos() {
      try {
        this.form = {};
        this.bandera_boton_buscar = false;
      } catch (error) {
        console.log(error);
      }
    },
    verDocumento(item) {
      this.$bus.$emit("openDialogVerDocumento", item);
    },
    async cargarListaUnidadesGenerales() {
      try {
        let res = await this.$service.graphql({
          query: `
                query{
                  vUnidadesGeneraless(lista_niveles:"0,1"){
                    rows{
                      id_unidad
                      nombre_unidad
                      nivel
                    }
                  }
                }
            `
        });
        this.unidades_generales = res.vUnidadesGeneraless.rows;
      } catch (error) {
        console.log(error);
      }
    },
    verReporte(item,valor) {
      item.correlativo=item.secuencia
      item.gestion=item.fecha_desde.substring(0,4)
      item.reprogramacion = valor; //programacion=0,repro=1
      console.log(item)
      this.$bus.$emit("openDialogVerReporte", item);
    },
    async cargarListaUnidadesEspecificas() {
      try {
        let res = await this.$service.graphql({
          query: `
                query{
                  vUnidadesGeneraless{
                    rows{
                      id_unidad
                      nombre_unidad
                      nivel
                    }
                  }
                }
            `
        });
        this.unidades_especificas = res.vUnidadesGeneraless.rows;
      } catch (error) {
        console.log(error);
      }
    }
  },
  // Definición de componentes importados
  components: {
    VerSeguimientoVacacion,
    VerReporte,
    // VerDocumento,
    // VerPermiso
  }
};
</script>

<style lang="scss">
.text-field-reducido {
  padding: 0em 0em 0em 0em;
  margin: 0em 0em 0em 0em;
  .v-input__control {
    padding: 0em 0em 0em 0em;
    margin: 0em 0em 0em 0em;
    .v-text-field__slot {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
      .input {
        background: greenyellow;
        padding: 0em 0em 0em 0em;
        margin: 0em 0em 0em 0em;
      }
    }
    .v-input__slot {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
    }
    .v-text-field__details {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
      .v-messages {
        padding: 0em 0em 0em 0em;
        margin: 0em 0em 0em 0em;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/reportes/ReporteVacaciones.vue